// extracted by mini-css-extract-plugin
export default {"deleteOverlay":"J3-z","cancel":"K3-z","disabled":"L3-z","delete":"M3-z"};